/* ================================================================
   LegBilligt — "Læg i kurv" pa vores egne raekkekort
   Delegeret klik, sa knapper der kommer til senere ogsaa virker.
   Kortet er selv et link til varen, derfor stopper vi klikket.
   ================================================================ */
(function(){
  'use strict';

  function opdaterKurvIkon(){
    var boble = document.getElementById('cart-icon-bubble');
    if(!boble) return;
    fetch('/?sections=cart-icon-bubble')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if(!d || !d['cart-icon-bubble']) return;
        var midl = document.createElement('div');
        midl.innerHTML = d['cart-icon-bubble'];
        var nyt = midl.querySelector('#cart-icon-bubble');
        boble.innerHTML = nyt ? nyt.innerHTML : d['cart-icon-bubble'];
      })
      .catch(function(){});
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('.lbbr-kurv[data-v]') : null;
    if(!b) return;
    e.preventDefault();
    e.stopPropagation();
    if(b.disabled) return;

    var org = b.textContent;
    b.disabled = true;
    b.textContent = 'Lægger i kurv …';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.dataset.v), quantity: 1 }] })
    })
    .then(function(r){ return r.json(); })
    .then(function(svar){
      if(svar && svar.status && svar.status !== 200) throw new Error('fejl');
      opdaterKurvIkon();
      b.textContent = 'Lagt i kurven ✓';
      b.classList.add('ok');
      setTimeout(function(){
        b.textContent = org;
        b.classList.remove('ok');
        b.disabled = false;
      }, 1600);
    })
    .catch(function(){
      b.textContent = 'Prøv igen';
      setTimeout(function(){ b.textContent = org; b.disabled = false; }, 1600);
    });
  }, true);
})();
